import store from "~/store/index"
import {
  GetLabelByCodesDothings,
  GetCodeByLabelsDothings
} from "~/functions/dict"
/**
 * @description: 通过code获取label
 * @param {*}
 * @return {*}
 * @author: syx
 */
export const GetLabelByCodeFilter = (val, type, defaultVal) => {
  const { format } = store.state.dictConfig
  const dictList = store.state.dictCodes
  let list = []
  //如果没找到此类型的数据
  if (!dictList || !dictList[type]) {
    store.actions.getDictDataObj(type).then((data) => {
      list = data[type]
      if (!list) {
        new Error(`不存在类型为：${type} 的字典字段，请确认后再填写`)
        return
      }
      const targetItem = list.find((item) => {
        return item[format.value] === val
      })
      return targetItem ? targetItem[format.label] : defaultVal ?? ""
    })
  } else {
    list = dictList[type]
    const targetItem = list.find((item) => {
      return item[format.value] === val
    })
    return targetItem ? targetItem[format.label] : defaultVal ?? ""
  }
}

export const GetLabelByCodesFilter = (vals, type, options) => {
  const defaultOptions = {
    defaultVal: "",
    formatFun: (arr, format) => {
      return arr
        .map((item) => {
          return item[format.label]
        })
        .join(",")
    },
    spacer: ","
  }
  Object.assign(defaultOptions, options)
  let values = []
  if (Array.isArray(vals)) {
    values = vals
  } else if (typeof vals === "string") {
    values = vals.split(defaultOptions.spacer)
  }

  const { format } = store.state.dictConfig
  const dictList = store.state.dictCodes

  let list = []
  //如果没找到此类型的数据
  if (!dictList || !dictList[type]) {
    store.actions.getDictDataObj(type).then((data) => {
      list = data[type]
      if (!list) {
        new Error(`不存在类型为：${type} 的字典字段，请确认后再填写`)
        return
      }
      const targetArr = GetLabelByCodesDothings(
        values,
        list,
        format,
        defaultOptions.defaultVal
      )
      return targetArr && targetArr.length > 0
        ? defaultOptions.formatFun(targetArr, format)
        : defaultOptions.defaultVal
    })
  } else {
    list = dictList[type]
    const targetArr = GetLabelByCodesDothings(
      values,
      list,
      format,
      defaultOptions.defaultVal
    )
    return targetArr && targetArr.length > 0
      ? defaultOptions.formatFun(targetArr, format)
      : defaultOptions.defaultVal
  }
}

/**
 * @description: 通过label获取code
 * @param {*}
 * @return {*}
 * @author: syx
 */
export const GetCodeByLabelFilter = (val, type, defaultVal) => {
  const { format } = store.state.dictConfig
  const dictList = store.state.dictCodes
  let list = []
  //如果没找到此类型的数据
  if (!dictList || !dictList[type]) {
    store.actions.getDictDataObj(type).then((data) => {
      list = data[type]
      if (!list) {
        new Error(`不存在类型为：${type} 的字典字段，请确认后再填写`)
        return
      }
      const targetItem = list.find((item) => {
        return item[format.label] === val
      })
      return targetItem ? targetItem[format.value] : defaultVal ?? ""
    })
  } else {
    list = dictList[type]
    const targetItem = list.find((item) => {
      return item[format.label] === val
    })
    return targetItem ? targetItem[format.value] : defaultVal ?? ""
  }
}

export const GetCodeByLabelsFilter = (vals, type, options) => {
  const defaultOptions = {
    defaultVal: "",
    formatFun: (arr, format) => {
      return arr
        .map((item) => {
          return item[format.value]
        })
        .join(",")
    },
    spacer: ","
  }
  Object.assign(defaultOptions, options)
  let values = []
  if (Array.isArray(vals)) {
    values = vals
  } else if (typeof vals === "string") {
    values = vals.split(defaultOptions.spacer)
  }

  const { format } = store.state.dictConfig
  const dictList = store.state.dictCodes

  let list = []
  //如果没找到此类型的数据
  if (!dictList || !dictList[type]) {
    store.actions.getDictDataObj(type).then((data) => {
      list = data[type]
      if (!list) {
        new Error(`不存在类型为：${type} 的字典字段，请确认后再填写`)
        return
      }
      const targetArr = GetCodeByLabelsDothings(
        values,
        list,
        format,
        defaultOptions.defaultVal
      )
      return targetArr && targetArr.length > 0
        ? defaultOptions.formatFun(targetArr, format)
        : defaultOptions.defaultVal
    })
  } else {
    list = dictList[type]
    const targetArr = GetCodeByLabelsDothings(
      values,
      list,
      format,
      defaultOptions.defaultVal
    )
    return targetArr && targetArr.length > 0
      ? defaultOptions.formatFun(targetArr, format)
      : defaultOptions.defaultVal
  }
}
